import { AccountSwitcher } from "@/components/accountSwitcher/AccountSwitcher.tsx";
import { SettingsNavButton } from "@/components/layout/SettingsNavButton.tsx";
import { panelTrailingIconClass } from "@/components/layout/SplitPanel/SplitPanelHeader.tsx";
import { cn } from "@/lib/utils.ts";

/**
 * The bottom of the sidebar: which account you are in, and the way to settings.
 *
 * They sit together at the bottom because neither is about what the sidebar is
 * listing: they are the account you are doing all of it as, and the place you go
 * to change how it works. That leaves the header cluster to the actions that do
 * act on the list.
 *
 * The switcher takes the width and the gear pins right, so the account label has
 * room to read even at the sidebar's narrowest drag width, and the gear lands
 * under the collapse toggle directly above it.
 *
 * Kept out of `ThreadListPanel` so the mobile nav drawer can render the same
 * footer when its own list moves in there.
 */
export const SidebarFooter = () => (
  // `border-t` rather than a gap: the list above scrolls under this, so the rule
  // is what says the footer is a fixed shelf and not the end of the list.
  <div className="flex shrink-0 items-center border-t px-(--panel-gutter) py-2">
    <AccountSwitcher variant="row" />
    {/* `ml-auto` rather than a gap: the switcher is content-width, so the gear
        has to be pushed to the edge rather than trailing the label around. The
        pull is `panelTrailingIconClass` — the gear ends this row, so its glyph,
        not its box, is what has to sit on the gutter. */}
    <div className={cn("ml-auto shrink-0", panelTrailingIconClass)}>
      <SettingsNavButton />
    </div>
  </div>
);
